export default {
    welcomeGreeting: "Welcome!",
    welcomeMessage: "Great that you're going to try the Bwell method. Good luck!",
    startButton: "Get started",
    subtext: "Start your wellbeing journey today"
  };